<template>
    <nav class="menubar">
        <ul>
            <li><router-link v-bind:class="{ active: active == 'home' }" :to="{ name: 'Home' }">Mine meldinger</router-link></li>
            <li><router-link v-bind:class="{ active: active == 'post' }" :to="{ name: 'Post' }">Skriv ny melding</router-link></li>
            <li><router-link v-bind:class="{ active: active == 'profile' }" :to="{ name: 'Profile' }">Endre passord eller e-post</router-link></li>
            <li><a @click.prevent="logout">Logg ut </a></li>
        </ul>
    </nav>
</template>
<script>
export default {
    props: {
        active:''
    },
    methods: {
      logout() {
        var _this = this;
        this.$auth.logout({
            success() {
                console.log('success ');
            },
            error() {
                console.log('error ');
            }
        });
      }
    }
}
</script>
<style lang="scss">  
    .menubar {
        margin-left:rem-calc(30);

        @include breakpoint(large up) {
            margin-top:rem-calc(-10);
            margin-bottom:rem-calc(20);
        }

        ul {
            display:block;
            margin:0 auto;
            padding:0;
            list-style-type:none;

            @include breakpoint(large up) {
                display:flex;
                align-items: flex-start;
            }

            li {
                a {
                    padding:rem-calc(0 5 5 5);
                    color:#000;
                    text-decoration:none;
                    text-transform: uppercase;

                    &:hover { 
                        color:#000;
                        text-decoration: underline;
                    }
                    &.active { 
                        text-decoration: underline;
                    }
                }
            }

            @include breakpoint(large up) {
                li + li a {
                    margin-left: rem-calc(20);
                }
                li:last-child {
                    margin-left: auto;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Menu.vue